import React from 'react';
import { scrollToBuy, CHECKOUT_URL } from '../config';
import { ArrowRight } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  isFinal?: boolean;
  className?: string;
  fullWidth?: boolean;
}
export function CtaButton({
  children,
  isFinal = false,
  className = '',
  fullWidth = false
}: CtaButtonProps) {
  const baseClasses = `inline-flex items-center justify-center gap-2 bg-brand-accent hover:bg-brand-accentHover text-white font-bold py-4 px-8 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 ${fullWidth ? 'w-full' : ''} ${className}`;
  if (isFinal) {
    return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={baseClasses} data-id="element-242">
        {children}
        <ArrowRight className="w-5 h-5" data-id="element-243" />
      </a>;
  }
  return <button onClick={scrollToBuy} className={baseClasses} data-id="element-244">
      {children}
      <ArrowRight className="w-5 h-5" data-id="element-245" />
    </button>;
}